import ProtectedRoute from 'auth/ProtectedRoute';
import HpvTestResultImportView from 'components/lab-central/HpvTestResultImportView';
import TestResultImportView from 'components/lab-central/TestResultImportView';
import PatientCentral from 'components/patient-entry/PatientCentral';
import { PatientCentralRefDataContextProviderWrapper } from 'components/patient-entry/PatientCentralRefDataContext';
import PatientEntryView from 'components/patient-entry/PatientEntryView';
import EditPoolTestKit from 'components/pool-testkit/EditPoolTestKit';
import React, { Fragment } from 'react';
import { Switch } from 'react-router';

const PatientEntryHome = () => (
    <Fragment>
      <PatientCentralRefDataContextProviderWrapper>
        <Switch>
          <ProtectedRoute path="/patient-central/onboard" exact component={PatientEntryView}/>
          <ProtectedRoute path="/patient-central/onboard/:id" exact component={PatientEntryView}/>
          <ProtectedRoute path="/patient-central/pool-testkit-registration/edit" exact component={EditPoolTestKit}/>
          <ProtectedRoute path="/patient-central/import-test-result" exact component={TestResultImportView}/>
          <ProtectedRoute path="/patient-central/import-hpv-test-result" exact component={HpvTestResultImportView}/>
          <ProtectedRoute path="/patient-central" exact component={PatientCentral}/>
        </Switch>
      </PatientCentralRefDataContextProviderWrapper>
    </Fragment>
);

export default PatientEntryHome;
